import React from 'react'
import ReactDOM from 'react-dom'
import { LoadingOverlayProvider } from './LoadingOverlay/LoadingOverlayContext'
import LoadingOverlay from './LoadingOverlay/LoadingOverlay'
import App from './App'
import InternetWarning from './helpers/InternetWarning'

ReactDOM.render(
  <>
    <div className="notranslate" translate="no">
      <InternetWarning />
      <LoadingOverlayProvider>
        <LoadingOverlay />
        <App />
      </LoadingOverlayProvider>
    </div>
  </>,
  document.getElementById('root')
)
